const getters = {
    getReports(state) {
        return state.reports;
      },
    getIMEIAction(state) {
       return state.imeiAction;
    },
    getStorePayoutReportDataToRedirectNERPData(state) {
      return state.storePayoutReportDataToRedirectNERPData;
    }
}

export default getters